export const allServiceStop = {
    title: 'Service emergency stop',
    restart: 'Service revival',
    restartMsg: 'This operation restores all emergency suspended accounts. is this good?',
    warnMsg: 'This operation will cause an emergency suspension of all accounts. is this good?',
    confirmMsg: 'If confirmed, *please enter "Emergency Stop of Service" in the below box.',
    cancelText: 'Cancel',
    confirmMsgError: 'The message you entered is incorrect.',
    okText: 'Yes',
    successMsg: 'Processing ended normally.',
    errorMsg: 'Processing failed.'
}
